<template>
    <table class="table table-hoverable timeline-details-content">
        <thead>
        <tr>
            <th>Attribute</th>
            <th>New Value</th>
            <th>Previous Value</th>
        </tr>
        </thead>
        <tbody>
        <column-row v-for="(row, rowIndex) in table.data" :row="row" :columns="3" :key="rowIndex">
            <template slot-scope="{row: {attribute, newValue, previousValue, isRestriction}}">
                <td width="33%">
                    <attribute-name :name="attribute"/>
                </td>
                <td width="33%">
                    <filter-summary v-if="isRestriction" :condition="newValue" :is-criteria="true"
                                    :resource-field="{type: 'text'}" divider-icon="arrow-right"/>
                    <attribute-value v-else :name="attribute" :value="newValue"/>
                </td>
                <td>
                    <filter-summary v-if="isRestriction" :condition="previousValue" :is-criteria="true"
                                    :resource-field="{type: 'text'}" divider-icon="arrow-right"/>
                    <attribute-value v-else :name="attribute" :value="previousValue"/>
                </td>
            </template>
        </column-row>
        </tbody>
    </table>
</template>

<script>
    import FilterSummary from '@/components/query/filter-summary';
    import ColumnRow from './column-row';
    import AttributeValue from './attribute-value';
    import AttributeName from './attribute-name';


    export default {
        name: 'three-column-table',
        components: {
            FilterSummary,
            ColumnRow,
            AttributeValue,
            AttributeName,
        },
        props: {
            table: Object,
        },
    };
</script>
